import m from 'mithril'

export default {
  view: vnode => {
    const hansen = require('./Hansen.png')
    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-19-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>

        <h3 className="log-book-text mod-h3">Danmark er under pres - både fra USA og Sovjet</h3>

        <p className="log-book-text">28 marts 1957: Sovjets ministerpræsident Nikolaj Bulgogin skriver i et åbent brev, at Grønland er omdannet til militærbase for De Forenede Stater og er ‘uden for Danmarks kontrol’. Han advarer om, at det i tilfælde af atomkrig vil være ‘selvmord’ for Danmark.</p> 

        <p className="log-book-text">13. november 1957: Den amerikanske ambassadør Val Petersen er på besøg hos statsminister H.C.Hansen. Petersen spørger, om Danmark vil underrettes, hvis USA placerer atomvåben i Grønland. </p> 

        <p className="log-book-text">16. november 1957: H.C.Hansen svarer amerikanerne, at henvendelsen ikke indeholder konkrete forslag om udstationering af atomvåben, og at han ikke har yderligere kommentarer.   </p> 

        <p className="log-book-text">Få måneder senere ankommer de første amerikanske atomvåben til Grønland.  </p> 
  
          <figure className="log-book-figure">
            <img src={hansen} className="log-book-img" />     
            <figcaption className="log-book-figcaption">
            Valgplakat fra Statsminister H.C. Hansen, folketingsvalget maj 1957. 
              </figcaption>       
          </figure>
        </div>
      </div>
    )
  }
}
